/* eslint-disable no-console */
import { useState, useEffect, useCallback } from 'react';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { mapProcurementDocuments } from '../../TenderOpening/utils/tenderOpeningHelpers';

const useProcurementDocuments = (
  procId,
  { enabled = true, isActive = true } = {}
) => {
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDocuments = useCallback(async () => {
    const token = getAuthToken();
    if (!token || !procId || !enabled) return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `${api.API_URL}/procurement/get-procurement-document?ProcurementId=${procId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to load supporting documents');
      }

      const result = await response.json();
      setDocuments(mapProcurementDocuments(result));
    } catch (err) {
      console.error('Error fetching procurement documents:', err);
      setDocuments([]);
    } finally {
      setIsLoading(false);
    }
  }, [procId, enabled]);

  const refresh = useCallback(() => fetchDocuments(), [fetchDocuments]);

  useEffect(() => {
    if (!enabled || !procId || !isActive) return;
    fetchDocuments();
  }, [enabled, procId, isActive, fetchDocuments]);

  return { documents, isLoading, refresh };
};

export default useProcurementDocuments;
